import { EditorDesignTokens } from '@primeuix/themes/types/editor';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/editor/index.ts
const ed = componentCommon.editor;

export const EditorTelekomDT: EditorDesignTokens = {
  toolbar: {
    background: t(ed.toolbar.background),
    borderColor: t(ed.toolbar.border.color),
    borderRadius: t(ed.toolbar.border.radius),
  },
  toolbarItem: {
    color: t(ed.toolbar.item.color),
    hoverColor: t(ed.toolbar.item.hover.color),
    activeColor: t(ed.toolbar.item.active.color),
  },
  overlay: {
    background: t(ed.overlay.background),
    borderColor: t(ed.overlay.border.color),
    borderRadius: t(ed.overlay.border.radius),
    color: t(ed.overlay.color),
  },
  overlayOption: {
    color: t(ed.overlay.option.color),
    focusBackground: t(ed.overlay.option.focus.background),
    focusColor: t(ed.overlay.option.focus.color),
    borderRadius: t(ed.overlay.option.border.radius),
  },
  content: {
    background: t(ed.content.background),
    borderColor: t(ed.content.border.color),
    color: t(ed.content.color),
    borderRadius: t(ed.content.border.radius),
  },
};
